import EmptyState from '@/components/linear/empty-state';
import PageToolbar from '@/components/linear/page-toolbar';

export default function Index() {
  return (
    <div className="ln-page">
      <PageToolbar title="Initiatives" showNew={false} />
      <div className="ln-page-scroll">
        <EmptyState title="No initiatives" description="Initiatives group related projects." />
      </div>
    </div>
  );
}
